import { render, staticRenderFns } from "./SelectProjectModal.vue?vue&type=template&id=f1f25e84"
import script from "./SelectProjectModal.vue?vue&type=script&lang=js"
export * from "./SelectProjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports